import { Subscription } from 'rxjs';

export class ObservableHelper {
    static unsubscribeAll(subs: Subscription[]) {
        if (subs && Array.isArray(subs)) {
            subs.forEach(it => it.unsubscribe());
        }
    }
}
